@if (paramMap$ | async; as paramMap) {
	<stages-dialog2 #dialog>
		<stages-dialog-header />
		@if (credentialsValid) {
			@if (fileProperties$ | async; as fileProperties) {
				<h1 [translate]="getHeaderMessageKey(fileProperties)" [translateParams]="{ name: fileProperties.name }"></h1>
				<form [formGroup]="formModel" class="content file-add-dialog" name="group" #formElement>
					<stages-upload
						[uploadCompletedCallback]="getUploadCompletedCallback(fileProperties)"
						[uploadUrl]="uploadUrl"
						(uploadError)="handleError($event)"
					>
					</stages-upload>
					@if (errorMessage) {
						<div class="error hint">
							<span>{{ errorMessage }}</span>
						</div>
					}
					@if (filesToCreateOrUpdate.length) {
						<article class="new-versions">
							<ul class="list dense" formArrayName="displayName">
								@for (
									displayNameControl of $any(formModel.get("displayName"))?.controls;
									track displayNameControl;
									let i = $index
								) {
									<li class="list-item">
										<div class="label">
											<i class="ico ico-file"></i>
											<div class="text">
												<input type="hidden" [formControlName]="i" />
												<h4>{{ displayNameControl.value }}</h4>
												<p
													[translate]="getNewVersionMessageKey(fileProperties)"
													[translateParams]="{ name: getUpdateFilename(i) }"
												></p>
												@if (displayNameControl.errors) {
													<div class="errors">
														@if (displayNameControl.errors.filetype) {
															<div
																class="error"
																translate="input.typeMismatch"
																[translateParams]="{ filetype: fileProperties.fileType }"
															></div>
														}
														@if (displayNameControl.errors.alreadySelected) {
															<div class="error" translate="input.alreadySelected"></div>
														}
													</div>
												}
											</div>
										</div>
									</li>
								}
							</ul>
						</article>
					}
					<article class="form properties">
						<stages-attribute-edit
							[attributeTypes]="fileProperties.attributeTypes"
							[attributes]="fileProperties.attributes"
							[form]="formModel"
							(change)="hasFormChanges(fileProperties)"
						>
						</stages-attribute-edit>
						@if (isNotifyUsersAllowed(fileProperties)) {
							<div class="input-container">
								<label for="notify" class="input-label" translate="files.notification.notify.users"></label>
								<div>
									<input
										type="checkbox"
										hidden="hidden"
										id="notify"
										name="notify"
										[checked]="notifyUsers"
										(change)="showNotificationOptions()"
									/>
									<label for="notify" class="switch"></label>
								</div>
							</div>
						}
					</article>
					@if (notifyUsers) {
						<stages-files-notifications
							(notificationInformation)="setNotificationInformation($event)"
							[isNewFile]="false"
						>
						</stages-files-notifications>
					}
				</form>
				<footer>
					<div class="buttons">
						<button class="button sm cancel" translate="cancel" (click)="dialog.close()"></button>
						<button class="button sm save" [disabled]="saveButtonDisabled()" (click)="saveClicked(fileProperties)">
							@if (!saveInProgress) {
								<span translate="files.start.upload.button"></span>
							}
							@if (saveInProgress) {
								<stages-spin size="s"></stages-spin>
							}
						</button>
					</div>
				</footer>
			} @else {
				@if (loadingError$ | async; as error) {
					<h1 translate="error.title"></h1>
				}
				<stages-popup-content>
					<stages-loading-error-embeddable [credentialsValid]="credentialsValid" [loadingError$]="loadingError$" />
				</stages-popup-content>
				<stages-popup-footer [hasCancelButton]="false" [buttons]="buttons" />
			}
		} @else {
			@if (!credentialsValid && !oAuthUrl) {
				<stages-files-auth-embeddable #auth [cmsTypeMessageKey]="cmsTypeMessageKey!" />
			}
			@if (!credentialsValid && oAuthUrl) {
				<stages-files-oauth-embeddable-confirm
					[cmsTypeMessageKey]="cmsTypeMessageKey!"
					[authUrl]="oAuthUrl"
					[closeCallback]="close"
				/>
			}
		}
	</stages-dialog2>
}
